<!-- Sign _in code start -->
<section class="sign-in_gail-gas d-flex align-items-center">
    <div class="container-fluid p-0">
        <div class="row d-flex justify-content-end">
          

            <!-- <div class="welcomeText">
                <h2>Welcome to <span>  CNG  Sales</span> </h2>
            </div> -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-8 bgContentSet">
                <div class="cardLoginContent">
                    <img src="images/login-page-res.png" alt="logo" >
                     <div class="contentWrapp">
                        <ul>
                            <li>
                                <div class="logoIcon">
                                    <img src="images/logo.svg" alt="logo">
                                </div>
                            </li>
                            <li><h1>Welcome to CNG Sales </h1></li>
                            <li>
                                <h4>Fuelling Greener Future</h4>
                                <p>Innovating today for a greener tomorrow</p>
                            </li>
                        </ul>
                     </div>
                </div>
            </div>
            
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-4 signSet">
                <div class="sign-in-cred-box">
                    
                        <div class="logoIcon">
                            <a routerLink="/login/login" routerLinkActive="active" >      <img src="images/logo.svg" alt="logo"></a>
                        </div>               
                    <h4>Forgot Password</h4>
                    <form id="frmlogin_login" [formGroup]="forgotPasswordForm">
                        <div class="form-input-signcred">
                            <div class="mb-3">
                                <label class="form-label fieldRequired">Mobile Number</label>
                                <input formControlName="Phone" type="text" class="form-control">
                            </div>
                            <div class="d-flex justify-content-end send-otp-forgotpass mb-3">
                                <button type="button" (click)="sendOTP()">Send OTP</button>
                            </div>
                        </div>
                        <div *ngIf="otpFlag" class="form-input-signcred">
                            <div class="mb-3">
                                <input type="number" formControlName="otp" class="form-control" placeholder="Enter OTP">
                            </div>
                            <div class="mb-1">
                                <label class="form-label">Enter New Password</label>
                                <div class="relative">
                                    <input formControlName="password" class="form-control" [type]="showNewPassword ? 'text' : 'password'"/>
                                    <button class="visibileEyeOnOff" type="button" (click)="toggleNewPasswordVisibility()">
                             
                                        <i class="bi" [ngClass]="showNewPassword ? 'bi-eye-fill' : 'bi-eye-slash-fill'"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="mb-5 mb-1450">
                                <label class="form-label">Confirm Password</label>
                                <div class="relative">
                                    <input formControlName="confirmPassword" class="form-control" [type]="showConfirmPassword ? 'text' : 'password'"/>
                                    <button class="visibileEyeOnOff" type="button" (click)="toggleConfirmPasswordVisibility()">
                                        <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-fill' : 'bi-eye-slash-fill'"></i>
                                    </button>
                                </div>
                            </div>
                        
                        <button class="btn w-100 login-btn-credmain mb-4 mb-1450-bottom" type="button" (click)="forgotPasswordFormSubmit()">Reset Password</button>
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
